/* ============================================================
   CIELO SPORTS CLUB — Anchor-Scroll
   Behebt das „Überschießen" bei Sprung-Links zu Ankern weit
   unten auf der Seite: Beim Klick oben sind die Bilder dazwischen
   noch lazy → Seite ist zu kurz → nativer Smooth-Jump landet am
   Seitenende. Wir übernehmen den Sprung, rechnen den Sticky-Header
   ein und KORRIGIEREN nach, während Bilder nachladen (Layout-Shift).
   ============================================================ */
(function () {
  if (window.__cscAnchorScroll) return;
  window.__cscAnchorScroll = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var h = parseInt(raw, 10);
    if (isNaN(h)) h = 90;
    return h + 224; /* Luft unter dem Header (24px Basis + 200px Extra-Abstand) */
  }

  function maxScroll() {
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }

  /* Absolute Ziel-Scrollposition, auf den scrollbaren Bereich geklemmt. */
  function targetY(el) {
    var y = el.getBoundingClientRect().top + window.scrollY - headerOffset();
    return Math.round(Math.max(0, Math.min(y, maxScroll())));
  }

  /* Ziel „anheften": Lazy-Bilder & Reveal-Animationen verschieben das
     Formular noch sekundenlang nach dem Klick. Wir folgen dem Ziel per
     rAF und scrollen nur neu, wenn es driftet — bis es ~0.7 s ruhig ist
     (oder nach 3 s Schluss). So landet das Formular zuverlässig oben,
     statt dass ein veralteter Smooth-Scroll ans Seitenende schießt. */
  function scrollToEl(el) {
    if (!el) return;
    var behavior = reduced ? 'auto' : 'smooth';
    var last = null;
    var calmStart = 0;

    function frame(now) {
      var t = targetY(el);
      if (last === null || Math.abs(t - last) > 2) {
        last = t;
        calmStart = now;
        window.scrollTo({ top: t, behavior: behavior });
      }
      if (now - calmStart < 700 && now <= frame.deadline) {
        requestAnimationFrame(frame);
      }
    }
    frame.deadline = (typeof performance !== 'undefined' ? performance.now() : 0) + 3000;
    requestAnimationFrame(frame);
  }

  function onClick(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' && href.indexOf('#') === -1) return;

    var url;
    try { url = new URL(a.href, location.href); } catch (_) { return; }
    /* Nur In-Page-Anker auf derselben Seite. */
    if (url.pathname !== location.pathname || url.hash.length < 2) return;

    var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!el) return; /* unbekannter Anker → normalem Verhalten überlassen */

    e.preventDefault();
    if (history.pushState) history.pushState(null, '', url.hash);
    scrollToEl(el);
  }

  document.addEventListener('click', onClick);

  /* Cross-Page-Navigation, die mit #Anker landet (z. B. von anderer Seite). */
  if (location.hash && location.hash.length > 1) {
    window.addEventListener('load', function () {
      var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (el) setTimeout(function () { scrollToEl(el); }, 80);
    });
  }
})();
